import { GroupsIntroController } from "./groupsIntroInterface";


export const createGroupsIntroController = (): GroupsIntroController => {
    return {
        useProps(data) {
            return {
                status: data.initial.state,
                settingsUrl: '/u/settings/privacy',
                videoUrl: "https://www.loom.com/embed/c59e765b206b42f989d3f9707a1bf8c2?sid=0f408c91-b00a-4b3e-b5ed-bdc66d15d955"
            }
        },
    }
}